import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Camera, CheckCircle2, ImagePlus, Loader2, Send, TriangleAlert, X } from "lucide-react";
import { api, API, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function BolleOperaioPage() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [errore, setErrore] = useState("");
  const [cantiere, setCantiere] = useState("");
  const [foto, setFoto] = useState(null);
  const [anteprima, setAnteprima] = useState("");
  const [invio, setInvio] = useState(false);
  const [inviata, setInviata] = useState(false);
  const cameraRef = useRef(null);
  const galleriaRef = useRef(null);

  useEffect(() => {
    const manifest = document.querySelector('link[rel="manifest"]') || document.createElement("link");
    manifest.rel = "manifest";
    manifest.href = `${API}/bolle-pubbliche/${token}/manifest.json`;
    if (!manifest.parentNode) document.head.appendChild(manifest);
    api.get(`/bolle-pubbliche/${token}`).then((r) => setInfo(r.data)).catch((e) => setErrore(formatApiError(e.response?.data?.detail)));
  }, [token]);

  useEffect(() => () => { if (anteprima) URL.revokeObjectURL(anteprima); }, [anteprima]);

  const scegli = (file) => {
    if (!file) return;
    if (anteprima) URL.revokeObjectURL(anteprima);
    setFoto(file);
    setAnteprima(URL.createObjectURL(file));
    setInviata(false);
  };

  const invia = async () => {
    if (!cantiere.trim()) return setErrore("Inserisci il nome del cantiere");
    if (!foto) return setErrore("Scatta o scegli la foto della bolla");
    setInvio(true); setErrore("");
    try {
      const dati = new FormData();
      dati.append("cantiere_nome", cantiere.trim());
      dati.append("foto", foto);
      await api.post(`/bolle-pubbliche/${token}`, dati, { headers: { "Content-Type": "multipart/form-data" } });
      setInviata(true); setFoto(null); setAnteprima(""); setCantiere("");
    } catch (e) { setErrore(formatApiError(e.response?.data?.detail)); }
    finally { setInvio(false); }
  };

  if (!info && !errore) return <Schermata><Loader2 className="h-8 w-8 animate-spin text-primary" /><p className="mt-3 text-muted-foreground">Apertura app...</p></Schermata>;
  if (!info) return <Schermata><TriangleAlert className="h-10 w-10 text-destructive" /><h1 className="font-heading text-2xl font-bold mt-4">Link non disponibile</h1><p className="text-muted-foreground mt-2">{errore}</p></Schermata>;

  return <div className="min-h-screen bg-[#f5f7fb] px-4 py-6 sm:py-10">
    <main className="mx-auto max-w-md overflow-hidden rounded-3xl border bg-white shadow-xl">
      <header className="bg-slate-950 px-6 py-6 text-white flex items-center gap-4">
        <img src="/icon-192.png" alt="ADUEA" className="h-14 w-14 rounded-xl bg-white object-contain" />
        <div><p className="text-xs font-bold tracking-[.2em] text-orange-400">CANTIEREPRO</p><h1 className="font-heading text-2xl font-bold">Bolle dal cantiere</h1></div>
      </header>
      <section className="p-6 space-y-5">
        <div><p className="text-sm text-muted-foreground">Operaio riconosciuto</p><p className="text-lg font-bold">{info.operaio_nome}</p></div>
        {inviata && <div className="rounded-xl bg-emerald-50 p-4 text-emerald-800 flex gap-3"><CheckCircle2 className="h-6 w-6 shrink-0"/><div><p className="font-bold">Bolla inviata correttamente</p><p className="text-sm">Puoi caricarne subito un’altra.</p></div></div>}
        <label className="block"><span className="text-sm font-semibold">Nome del cantiere *</span><Input value={cantiere} onChange={(e) => setCantiere(e.target.value)} placeholder="Es. Via Roma 24" className="mt-2 h-12" /></label>
        <input ref={cameraRef} type="file" accept="image/*" capture="environment" className="hidden" onChange={(e) => scegli(e.target.files?.[0])}/>
        <input ref={galleriaRef} type="file" accept="image/*" className="hidden" onChange={(e) => scegli(e.target.files?.[0])}/>
        {!anteprima ? <div className="grid grid-cols-2 gap-3">
          <Button className="h-24 flex-col gap-2" onClick={() => cameraRef.current?.click()}><Camera className="h-7 w-7"/>Scatta foto</Button>
          <Button variant="outline" className="h-24 flex-col gap-2" onClick={() => galleriaRef.current?.click()}><ImagePlus className="h-7 w-7"/>Galleria</Button>
        </div> : <div className="relative overflow-hidden rounded-2xl border bg-slate-100"><img src={anteprima} alt="Anteprima bolla" className="max-h-[390px] w-full object-contain"/><button aria-label="Rimuovi foto" onClick={() => { setFoto(null); setAnteprima(""); }} className="absolute right-3 top-3 rounded-full bg-black/70 p-2 text-white"><X className="h-5 w-5"/></button></div>}
        {errore && <p className="rounded-lg bg-red-50 p-3 text-sm font-semibold text-red-700">{errore}</p>}
        <Button onClick={invia} disabled={invio || !foto || !cantiere.trim()} className="h-12 w-full text-base"><Send className="mr-2 h-5 w-5"/>{invio ? "Invio in corso..." : "Invia bolla"}</Button>
        <p className="text-center text-xs text-muted-foreground">La foto sarà visibile esclusivamente nel gestionale ADUEA.</p>
      </section>
    </main>
  </div>;
}

function Schermata({ children }) { return <div className="min-h-screen bg-[#f5f7fb] flex items-center justify-center p-6"><div className="max-w-sm text-center">{children}</div></div>; }
